<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('BusinessUserAdminRightsSelfRemovalModalTitle')"
    :is-danger="true"
  >
    <template #default>
      <div>
        {{ $localize('BusinessUserAdminRightsSelfRemovalModalMessage') }}
      </div>
      <br>
      <div>
        {{ $localize('BusinessUserModalQuestion') }}
      </div>
    </template>
    <template #footer>
      <button
        ref="closeBtn"
        class="btn btn-outline-secondary"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </button>
      <button
        ref="deleteBtn"
        class="btn btn-danger"
        @click="emit('update')"
      >
        {{ $localize('Continue') }}
      </button>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  const emit = defineEmits < { 'update' }>();
  const visible = defineModel<boolean>({ default: false });
</script>
